export { default } from "./User";



// WEBPACK FOOTER //
// ./src/components/list-items/User/index.js